import { Asterisk } from "lucide-react";

export function Marquee({ items }) {
  const row = [...items, ...items];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-white/10 bg-surface py-5">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {row.map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-8 px-8 font-display text-2xl font-bold uppercase tracking-tight text-white/70 sm:text-3xl"
          >
            {item}
            <Asterisk className="h-6 w-6 text-brand" strokeWidth={2.5} />
          </span>
        ))}
      </div>
    </div>
  );
}
